import { render } from "./LegoSearchSku.vue?vue&type=template&id=aaeef85c"
import script from "./LegoSearchSku.vue?vue&type=script&lang=js"
export * from "./LegoSearchSku.vue?vue&type=script&lang=js"
script.render = render

export default script